/// useTranslation not needed
import React from 'react'
import Spinner from './Spinner'

interface SubmitButtonProps {
  disabled?: boolean
  invalid?: boolean
  submitting: boolean
  text?: string
  color?: string
  id?: string
  buttonClassName?: string
  error?: string | undefined
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  disabled = false,
  invalid,
  submitting,
  text = 'SAVE',
  color = 'primary',
  buttonClassName = '',
  id,
  error,
}) => (
  <>
    {invalid && error && <div className="alert alert-danger">{error}</div>}
    <button
      id={id || 'submit-button'}
      type="submit"
      className={
        `btn btn-${invalid ? 'warning' : color}` +
        (buttonClassName ? ' ' + buttonClassName : '')
      }
      disabled={disabled || submitting}
      style={{ minWidth: 160 }}
    >
      {submitting ? <Spinner xs active /> : text}
    </button>
  </>
)

export default SubmitButton
